import React, { useMemo } from 'react';
import { DesignSystemShadowProvider } from './DesignSystemShadowProvider';
import {
  RegionCurrencyContextProvider,
  WishlistCustomerKeyProvider,
  personalizationAPIClient,
} from '@skin-seoul/service';
import { PersonalizationClient, PersonalizationProvider, WebPersonalizationStorageAdapter } from '@skin-seoul/utils';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

type ShortcodeProviderProps = {
  children?: React.ReactNode;
};

const queryClient = new QueryClient();

const ShortcodeProvider = ({ children }: ShortcodeProviderProps) => {
  const personalizationClient = useMemo(
    () =>
      new PersonalizationClient({
        resolveActor: (currentActorId) => personalizationAPIClient.resolveActor(currentActorId),
        sendEvent: (payload) => personalizationAPIClient.trackEvent(payload),
        storage: new WebPersonalizationStorageAdapter(),
        skipResolveWhenSessionValid: true,
      }),
    [],
  );

  return (
    <DesignSystemShadowProvider>
      <QueryClientProvider client={queryClient}>
        <RegionCurrencyContextProvider>
          <PersonalizationProvider client={personalizationClient}>
            <WishlistCustomerKeyProvider>{children}</WishlistCustomerKeyProvider>
          </PersonalizationProvider>
        </RegionCurrencyContextProvider>
      </QueryClientProvider>
    </DesignSystemShadowProvider>
  );
};

export default ShortcodeProvider;
